import { useLoggedUser, useSessionPermission } from '@btime/react-session'

import { useIsPermalinkPage } from '../../session/permalinkToken'

export const useCanUpdateStatusChecker = (serviceOrder, newStatus) => {
  const currentStatus = serviceOrder?.serviceStatus?.name || serviceOrder?.status?.name
  const hasPermission = useSessionPermission('editServiceOrdersStatus')
  const user = useLoggedUser()

  const isPublic = useIsPermalinkPage()

  if (isPublic && newStatus) return false
  if (isPublic) return () => false

  const checker = newStatus => {
    switch (newStatus) {
      case 'completed':
        if (user.id === serviceOrder.user.id && ['received', 'open', 'pause', 'execution'].includes(currentStatus)) {
          return true
        }
        if (['pending'].includes(currentStatus)) {
          return true
        }
        return false

      case 'execution':
        return user.id === serviceOrder.user.id && ['received', 'open', 'pause'].includes(currentStatus)

      case 'pause':
        return user.id === serviceOrder.user.id && ['open', 'execution'].includes(currentStatus)

      case 'approved':
        return hasPermission && ['open', 'received', 'execution', 'paused', 'completed'].includes(currentStatus)

      case 'disapproved':
        return hasPermission && ['open', 'received', 'execution', 'paused', 'completed'].includes(currentStatus)

      case 'canceled':
        return hasPermission && currentStatus !== 'canceled'

      default:
        return false
    }
  }

  if (newStatus) return checker(newStatus)
  return checker
}
